// ============================
// === client/src/main.jsx ===
// ============================
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Initialize Dynamsoft WebTWAIN Product Key from env, if available
try {
  const key = import.meta.env.VITE_DWT_PRODUCT_KEY;

  console.log( key );
  
  if (key && typeof window !== 'undefined' && window.Dynamsoft && window.Dynamsoft.DWT) {
    window.Dynamsoft.DWT.ProductKey = String(key);
    // Ensure resources path is set if not already configured in HTML
    if (!window.Dynamsoft.DWT.ResourcesPath) {
      window.Dynamsoft.DWT.ResourcesPath = 'https://unpkg.com/dwt/dist';
    }
  }
} catch (_) {}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
